exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* style label to have specific height so that when title is hidden, alignment is maintained */\nlabel[data-v-6ce2e107] {\n  height: 27px;\n}\n", ""]);

// exports
